<template>
  <div class="app-container">
    <el-card shadow="never">
      <div class="filter-container">
        <div class="searchContainer">
          <el-input
            v-model="advertisersQuery.user_id"
            class="inputLabel"
            placeholder="请输入主账号id"
          />
          <el-input
            v-model="advertisersQuery.sub_uc_id"
            class="inputLabel"
            placeholder="请输入子账号id"
          />
          <el-input
            v-model="advertisersQuery.imgageId"
            class="inputLabel"
            placeholder="请输入创意id"
          />
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>
        <el-button class="filter-item" type="danger" @click="addDelItem">批量删除</el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between;"
      >
        <el-table-column
          label="图片id"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <el-checkbox
              @change="handleCheckChange(scope.row)"
            >{{ scope.row.imageId }}</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          prop="imageName"
          label="图片名称"
          align="center"
          width="180"
        />
        <el-table-column
          prop="sub_uc_name"
          label="子账号名称"
          align="center"
          width="180"
        />
        <el-table-column
          prop="preview_url"
          label="预览地址"
          align="center"
        >
          <template scope="scope">
            <el-image
              style="width: 80px; height: 80px"
              :src="scope.row.url"
              fit="cover"
              :preview-src-list="[scope.row.url]"
              @click.stop="handleClickStop"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="isCollectText"
          label="是否收藏"
          align="center"
          width="180"
        />
        <el-table-column
          prop="sourceType"
          label="图片来源类型"
          align="center"
          width="180"
        />
        <el-table-column
          prop="format"
          label="图片类型"
          align="center"
          width="180"
        />
        <el-table-column
          label="图片宽度(px)/图片高度(px)"
          align="center"
          width="180"
        >
          <template scope="scope">
            {{ scope.row.width }}x{{ scope.row.height }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sourceType"
          label="图片来源"
          align="center"
          width="180"
        />
        <el-table-column
          prop="addTimeText"
          label="创建时间"
          align="center"
          width="180"
        />
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="100"
        >
          <template scope="scope">
            <el-button type="danger" size="mini" @click="addDelItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <el-dialog
      title="确定删除"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="50%"
    >
      <el-tag
        v-for="item in deleteItems"
        :key="item.imageId"
        closable
        type="success"
        style="margin-left: 5px"
        @close="handleClose(item)"
      >
        {{ item.imageId }}
      </el-tag>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible = false,deleteItems.length===0">取 消</el-button>
        <el-button type="danger" @click="delImage">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { delImage, image_list } from '@/api/baiduAD'
export default {
  name: 'AccountList',
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      // table列表数据请求参数
      advertisersQuery: {
        user_id: null,
        sub_uc_id: null,
        page: 1, // 当前页码
        page_size: 10, // 广告在系统中的状态,
        imgageId: null
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      dialogVisible: false,
      accountIdsQuery: [],
      loading: false,
      deleteItems: []
    }
  },
  created() {
    this.getAdvertiserList()
  },
  methods: {
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    handleClose(item) {
      this.deleteItems = this.deleteItems.filter(i => i.imageId !== item.imageId)
    },
    getAdvertiserList() {
      this.loading = true
      image_list(this.advertisersQuery).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.advertisersQuery.page_size = 10
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {
        account_id: null,
        status: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
      this.getAdvertiserList()
    },
    addDelItem(val) {
      if (val) {
        this.deleteItems.push(val)
      }
      this.dialogVisible = true
    },
    handleCheckChange(val) {
      this.deleteItems.push(val)
    },
    delImage() {
      delImage({ imageIds: this.deleteItems.map(res => res.imageId) }).then(res => {
        this.$message.info(res.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  .inputLabel {
    margin-right: 10px;
    // display: inline-block;
    width: 200px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>

<!--<template>-->
<!--  <div class="app-container">-->
<!--    <el-card shadow="never">-->
<!--      <div class="filter-container">-->
<!--        <div class="searchContainer">-->
<!--          <el-input-->
<!--            v-model="advertisersQuery.account_id"-->
<!--            placeholder="请输入广告主"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="searchContainer">-->
<!--          <el-select-->
<!--            v-model="advertisersQuery.status"-->
<!--            placeholder="请选择状态"-->
<!--          >-->
<!--            <el-option-->
<!--              label="正常"-->
<!--              value="ADSTATUS_NORMAL"-->
<!--            />-->
<!--            <el-option-->
<!--              label="已删除"-->
<!--              value="ADSTATUS_DELETED"-->
<!--            />-->
<!--          </el-select>-->
<!--        </div>-->
<!--        <el-button-->
<!--          class="filter-item"-->
<!--          type="primary"-->
<!--          icon="el-icon-search"-->
<!--          @click="handleSearch"-->
<!--        >-->
<!--          搜索-->
<!--        </el-button>-->
<!--        <el-button-->
<!--          class="filter-item"-->
<!--          type="primary"-->
<!--          icon="el-icon-refresh"-->
<!--          @click="handleSearchReset"-->
<!--        >-->
<!--          重置-->
<!--        </el-button>-->
<!--        <el-button-->
<!--          class="filter-item"-->
<!--          type="primary"-->
<!--        >创建</el-button>-->
<!--        <el-button-->
<!--          class="filter-item"-->
<!--          type="primary"-->
<!--          @click="deleteAll"-->
<!--        >批量删除</el-button>-->
<!--      </div>-->
<!--      <div class="img_box" @scroll="handleScroll">-->
<!--        <div v-for="image in images " :key="image.id" :class="['image-card', imageClass(image)]">-->
<!--          <el-checkbox-->
<!--            v-model="selectedImages"-->
<!--            :label="image.id"-->
<!--            class="checkbox"-->
<!--          >-->
<!--            <span />-->
<!--          </el-checkbox>-->
<!--          <img :src="image.url" alt="image" class="image" @click="toggleCheckbox(image.id)">-->
<!--          <div class="image-info">-->
<!--            <p class="image-name">{{ image.imageName || '图片待命名' }}</p>-->
<!--            <p class="image-dimensions">{{ image.width }}×{{ image.height }}</p>-->
<!--          </div>-->
<!--          <div class="image-actions">-->
<!--            <button class="action-button" @click="zoomImage">-->
<!--              <i class="el-icon-zoom-in" />-->
<!--            </button>-->
<!--            <button class="action-button" @click="deleteImage">-->
<!--              <i class="el-icon-delete" />-->
<!--            </button>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-card>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--import { image_list } from '@/api/baiduAD'-->
<!--export default {-->
<!--  name: 'AccountList',-->
<!--  data() {-->
<!--    return {-->
<!--      search: {},-->
<!--      total: null, // 数据总条数啊-->
<!--      // table列表数据请求参数-->
<!--      advertisersQuery: {-->
<!--        account_id: null,-->
<!--        status: null,-->
<!--        page: 1, // 当前页码-->
<!--        page_size: 20 // 广告在系统中的状态-->
<!--      },-->
<!--      // 枚举值请求参数-->
<!--      enumerationsQuery: {-->
<!--        account_id: null,-->
<!--        api_name: 'account_management/advertisers'-->
<!--      },-->
<!--      dialogVisible: false,-->
<!--      accountIdsQuery: [], // 获取用户余额的参数-->
<!--      loading: false, // 加载动画-->
<!--      images: [],-->
<!--      selectedImages: []-->
<!--    }-->
<!--  },-->
<!--  created() {-->
<!--    this.getAdvertiserList()-->
<!--  },-->
<!--  methods: {-->
<!--    getAdvertiserList() {-->
<!--      this.loading = true-->
<!--      image_list(this.advertisersQuery).then(res => {-->
<!--        console.log('res:', res)-->
<!--        this.images = [...this.images, ...res.data.list]-->
<!--        this.total = res.data.total-->
<!--        this.loading = false-->
<!--      })-->
<!--    },-->
<!--    // 搜索-->
<!--    handleSearch() {-->
<!--      this.advertisersQuery.page = 1-->
<!--      this.advertisersQuery.page_size = 10-->
<!--      this.getAdvertiserList()-->
<!--    },-->
<!--    // 重置搜索框-->
<!--    handleSearchReset() {-->
<!--      this.advertisersQuery = {-->
<!--        account_id: null,-->
<!--        status: null,-->
<!--        page: 1,-->
<!--        page_size: 10-->
<!--      }-->
<!--      this.getAdvertiserList()-->
<!--    },-->
<!--    imageClass(image) {-->
<!--      if (image.width > image.height) {-->
<!--        return 'wide' // 横屏显示-->
<!--      } else if (image.height > image.width) {-->
<!--        return 'tall' // 竖屏显示-->
<!--      } else {-->
<!--        return 'square' // 正方形显示-->
<!--      }-->
<!--    },-->
<!--    zoomImage() {-->
<!--      console.log(11)-->
<!--    },-->
<!--    deleteImage() {-->
<!--      console.log(22)-->
<!--    },-->
<!--    handleScroll(event) {-->
<!--      const container = event.target-->
<!--      // 检查是否滚动到底部-->
<!--      if (container.scrollHeight - container.scrollTop === container.clientHeight) {-->
<!--        // 判断是否加载完所有数据-->
<!--        if (this.images.length >= this.total) {-->
<!--          this.$notify({-->
<!--            title: '警告',-->
<!--            message: '素材图片已经加载到底',-->
<!--            type: 'warning'-->
<!--          })-->
<!--          return-->
<!--        }-->
<!--        // 加载更多数据-->
<!--        this.advertisersQuery.page += 1-->
<!--        this.getAdvertiserList()-->
<!--      }-->
<!--    },-->
<!--    toggleCheckbox(imageId) {-->
<!--      const index = this.selectedImages.indexOf(imageId)-->
<!--      if (index > -1) {-->
<!--        this.selectedImages.splice(index, 1) // 取消选中-->
<!--      } else {-->
<!--        this.selectedImages.push(imageId) // 选中-->
<!--      }-->
<!--    },-->
<!--    deleteAll() {-->
<!--      console.log(this.selectedImages)-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style lang="less" scoped>-->
<!--::v-deep .block {-->
<!--  justify-content: left;-->
<!--}-->
<!--.searchContainer {-->
<!--  display: flex;-->
<!--  font-size: 14px;-->
<!--  float: left;-->
<!--  margin-right: 30px;-->
<!--  label {-->
<!--    padding-top: 10px;-->
<!--    vertical-align: middle;-->
<!--    font-weight: normal;-->
<!--  }-->
<!--  .inputLabel {-->
<!--    // display: inline-block;-->
<!--    width: 120px;-->
<!--  }-->
<!--}-->

<!--.overflow {-->
<!--  cursor: pointer;-->
<!--  text-overflow: ellipsis;-->
<!--  white-space: nowrap;-->
<!--  overflow: hidden;-->
<!--}-->

<!--.img_box {-->
<!--  display: flex;-->
<!--  flex-wrap: wrap;-->
<!--  justify-content: flex-start;-->
<!--  gap: 10px;-->
<!--  overflow-y: auto; /* 允许垂直滚动 */-->
<!--  height: 670px; /* 设置固定高度，确保容器可以滚动 */-->
<!--}-->
<!--.image-card {-->
<!--  display: block;-->
<!--  border: 1px solid #ebebeb;-->
<!--  border-radius: 6px;-->
<!--  overflow: hidden;-->
<!--  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);-->
<!--  background-color: #fff;-->
<!--  position: relative;-->
<!--  margin: 10px;-->
<!--  width: 200px; /* 设置固定宽度 */-->
<!--  flex-shrink: 0; /* 防止卡片缩小 */-->
<!--  flex-direction: column;-->
<!--  justify-content: space-between;-->
<!--  padding-bottom: 10px;-->
<!--}-->
<!--/* 正方形图片 */-->
<!--.square {-->
<!--  height: 242px;-->
<!--  object-fit: cover; /* 确保图片不变形 */-->
<!--}-->

<!--/* 横图：宽 > 高 */-->
<!--.landscape {-->
<!--  height: auto;-->
<!--  aspect-ratio: 16/9; /* 设定宽高比，如16:9 */-->
<!--  object-fit: cover; /* 确保图片不变形 */-->
<!--}-->

<!--/* 竖图：高 > 宽 */-->
<!--.portrait {-->
<!--  //height: 300px; /* 根据需要加高 */-->
<!--  object-fit: contain; /* 确保图片内容完整 */-->
<!--}-->

<!--.checkbox {-->
<!--  position: absolute;-->
<!--  top: 10px;-->
<!--  right: 10px;-->
<!--  z-index: 1;-->
<!--}-->

<!--.image {-->
<!--  width: 100%;-->
<!--  object-fit: cover; /* 确保图片适应容器 */-->
<!--}-->

<!--.image-info {-->
<!--  padding: 5px 10px; /* 减少内边距 */-->
<!--}-->

<!--.image-name {-->
<!--  font-size: 14px;-->
<!--  color: #333;-->
<!--  margin: 0;-->
<!--  text-align: left; /* 左对齐 */-->
<!--  white-space: nowrap;-->
<!--  overflow: hidden;-->
<!--  text-overflow: ellipsis;-->
<!--}-->

<!--.image-dimensions {-->
<!--  font-size: 12px;-->
<!--  color: #999;-->
<!--  margin: 3px 0 0 0; /* 减少外边距 */-->
<!--  text-align: left; /* 左对齐 */-->
<!--}-->

<!--.image-actions {-->
<!--  position: absolute;-->
<!--  bottom: 5px;-->
<!--  right: 10px;-->
<!--  display: flex;-->
<!--  gap: 10px; /* 两个图标之间的间距 */-->
<!--}-->

<!--.action-button {-->
<!--  background: none;-->
<!--  border: none;-->
<!--  cursor: pointer;-->
<!--  color: #666;-->
<!--}-->

<!--.action-button:hover {-->
<!--  color: #333;-->
<!--}-->

<!--.action-button i {-->
<!--  font-size: 16px;-->
<!--}-->
<!--</style>-->
